import React, { useEffect, useState } from 'react';

const STAGES = [
  { until: 25, label: 'Initializing learning environment' },
  { until: 50, label: 'Loading workforce pathways' },
  { until: 75, label: 'Connecting employer network' },
  { until: 100, label: 'Preparing your dashboard' },
];

const BootScreen = ({ onDone }) => {
  const [pct, setPct] = useState(0);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Stage 1: black 400ms (handled via initial state), no progress
    // Stage 2: logo reveal begins at ~400ms (opacity animates via CSS)
    // Stage 3: progress bar animates from 1200 → 3500 (2300ms)
    const start = 1200;
    const duration = 2300;
    const t0 = performance.now();
    let raf;
    const tick = (t) => {
      const elapsed = t - t0;
      if (elapsed < start) {
        raf = requestAnimationFrame(tick);
        return;
      }
      const p = Math.min(100, ((elapsed - start) / duration) * 100);
      setPct(p);
      if (p < 100) raf = requestAnimationFrame(tick);
      else {
        // Stage 4: fade out then done
        setTimeout(() => {
          setFadeOut(true);
          setTimeout(() => onDone && onDone(), 400);
        }, 200);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [onDone]);

  const currentStage = STAGES.find((s) => pct <= s.until) || STAGES[STAGES.length - 1];

  return (
    <div
      className="absolute inset-0 z-40 flex flex-col items-center justify-center"
      style={{
        background: '#0f2744',
        opacity: fadeOut ? 0 : 1,
        transition: 'opacity 400ms ease-out',
      }}
      role="status"
      aria-label="AssistivOS is loading"
      aria-live="polite"
      data-testid="proto-boot"
    >
      <div
        style={{
          opacity: pct > 0 || true ? 1 : 0,
          transition: 'opacity 800ms ease-out 400ms',
          animation: 'proto-fade-up 800ms ease-out 400ms both',
        }}
      >
        <div className="p-display text-[42px] leading-none text-center" style={{ color: '#fafaf9', margin: 0 }}>
          <img src="/logo.png" alt="AssistivOS" style={{ height: 52, width: 'auto', display: 'block', margin: '0 auto' }} />
        </div>
        <div className="mt-3 text-[13px] text-center" style={{ color: '#64748b', fontFamily: 'var(--p-font-body)' }}>
          Powered by Tech Tradesmith Institute
        </div>
      </div>

      <div className="mt-10 w-full px-6" style={{ maxWidth: '360px' }}>
        <div className="w-full h-[3px] rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.15)' }}>
          <div
            className="h-full rounded-full"
            style={{ width: `${pct}%`, background: '#f97316', transition: 'width 120ms linear' }}
          />
        </div>
        <div className="mt-3 text-center text-[13px]" style={{ color: 'rgba(250,250,249,0.72)', fontFamily: 'var(--p-font-body)' }}>
          {currentStage.label}...
        </div>
      </div>
    </div>
  );
};

export default BootScreen;
